const SEC_HEADERS = {
  'User-Agent': 'GHOST-Community contact@ghost.community',
};

export const STOCKS = [
  { ticker: 'AAPL', name: 'Apple', nameCn: '苹果', cik: '0000320193', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/apple.svg' },
  { ticker: 'NVDA', name: 'NVIDIA', nameCn: '英伟达', cik: '0001045810', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/nvidia.svg' },
  { ticker: 'AMZN', name: 'Amazon', nameCn: '亚马逊', cik: '0001018724', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/amazon.svg' },
  { ticker: 'MSFT', name: 'Microsoft', nameCn: '微软', cik: '0000789019', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/microsoft.svg' },
  { ticker: 'TSLA', name: 'Tesla', nameCn: '特斯拉', cik: '0001318605', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/tesla.svg' },
  { ticker: 'META', name: 'Meta', nameCn: 'Meta', cik: '0001326801', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/meta.svg' },
  { ticker: 'GOOGL', name: 'Alphabet', nameCn: '谷歌', cik: '0001652044', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/google.svg' },
  { ticker: 'JPM', name: 'JPMorgan Chase', nameCn: '摩根大通', cik: '0000019617', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/jpmorganchase.svg' },
  { ticker: 'V', name: 'Visa', nameCn: 'Visa', cik: '0001403161', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/visa.svg' },
  { ticker: 'MA', name: 'Mastercard', nameCn: '万事达', cik: '0001141391', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/mastercard.svg' },
  { ticker: 'UNH', name: 'UnitedHealth', nameCn: '联合健康', cik: '0000731766', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/unitedhealthgroup.svg' },
  { ticker: 'WMT', name: 'Walmart', nameCn: '沃尔玛', cik: '0000104169', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/walmart.svg' },
  { ticker: 'XOM', name: 'Exxon Mobil', nameCn: '埃克森美孚', cik: '0000034088', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/exxonmobil.svg' },
  { ticker: 'KO', name: 'Coca-Cola', nameCn: '可口可乐', cik: '0000021344', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/cocacola.svg' },
  { ticker: 'BAC', name: 'Bank of America', nameCn: '美国银行', cik: '0000070858', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/bankofamerica.svg' },
  { ticker: 'AXP', name: 'American Express', nameCn: '美国运通', cik: '0000004962', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/americanexpress.svg' },
  { ticker: 'CVX', name: 'Chevron', nameCn: '雪佛龙', cik: '0000093410', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/chevron.svg' },
  { ticker: 'PG', name: 'Procter & Gamble', nameCn: '宝洁', cik: '0000080424', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/proctergamble.svg' },
  { ticker: 'AMD', name: 'AMD', nameCn: 'AMD', cik: '0000002488', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/amd.svg' },
  { ticker: 'NFLX', name: 'Netflix', nameCn: '奈飞', cik: '0001065280', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/netflix.svg' },
];

export const fallbackStockFundamentals = {
  AAPL: { revenue: 95.4, netIncome: 24.8, marketCap: 3120000000000, regularMarketPrice: 199.4, regularMarketChangePercent: 0.86, trailingPE: 31.2, revenueGrowth: 5.1, rating: 'hold' },
  NVDA: { revenue: 44.1, netIncome: 26.0, marketCap: 4210000000000, regularMarketPrice: 151.2, regularMarketChangePercent: 3.45, trailingPE: 48.6, revenueGrowth: 69.2, rating: 'buy' },
  AMZN: { revenue: 155.7, netIncome: 15.3, marketCap: 2300000000000, regularMarketPrice: 217.6, regularMarketChangePercent: 1.14, trailingPE: 36.8, revenueGrowth: 10.4, rating: 'buy' },
  MSFT: { revenue: 70.1, netIncome: 25.8, marketCap: 3680000000000, regularMarketPrice: 495.1, regularMarketChangePercent: 0.62, trailingPE: 37.4, revenueGrowth: 13.3, rating: 'buy' },
  TSLA: { revenue: 19.3, netIncome: 1.4, marketCap: 1030000000000, regularMarketPrice: 322.9, regularMarketChangePercent: -1.08, trailingPE: 184.2, revenueGrowth: -9.2, rating: 'watch' },
  META: { revenue: 42.3, netIncome: 16.6, marketCap: 1600000000000, regularMarketPrice: 637.2, regularMarketChangePercent: 1.71, trailingPE: 28.1, revenueGrowth: 16.1, rating: 'buy' },
  GOOGL: { revenue: 90.2, netIncome: 23.7, marketCap: 2200000000000, regularMarketPrice: 180.3, regularMarketChangePercent: 0.44, trailingPE: 24.7, revenueGrowth: 12.0, rating: 'hold' },
  JPM: { revenue: 45.7, netIncome: 14.6, marketCap: 720000000000, regularMarketPrice: 258.8, regularMarketChangePercent: 0.31, trailingPE: 14.4, revenueGrowth: 8.4, rating: 'hold' },
  AMD: { revenue: 7.4, netIncome: 0.7, marketCap: 278000000000, regularMarketPrice: 171.6, regularMarketChangePercent: 2.18, trailingPE: 44.2, revenueGrowth: 35.9, rating: 'buy' },
  NFLX: { revenue: 10.5, netIncome: 2.9, marketCap: 520000000000, regularMarketPrice: 1210.4, regularMarketChangePercent: 0.73, trailingPE: 52.1, revenueGrowth: 12.5, rating: 'hold' },
};

async function fetchYahooQuotes(tickers) {
  const symbols = tickers.join(',');
  const cacheKey = `stock_yahoo_quotes_${symbols}`;
  const cached = sessionStorage.getItem(cacheKey);
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      if (Date.now() - parsed.ts < 15 * 60 * 1000) return parsed.data;
    } catch { /* ignore bad cache */ }
  }

  const res = await fetch(`https://query1.finance.yahoo.com/v7/finance/quote?symbols=${symbols}`);
  if (!res.ok) throw new Error(`Yahoo quote ${res.status}`);
  const data = await res.json();
  const quotes = {};
  (data.quoteResponse?.result || []).forEach((quote) => {
    quotes[quote.symbol] = {
      marketCap: quote.marketCap ?? null,
      trailingPE: quote.trailingPE ?? null,
      fiftyTwoWeekHigh: quote.fiftyTwoWeekHigh ?? null,
      fiftyTwoWeekLow: quote.fiftyTwoWeekLow ?? null,
      dividendYield: quote.dividendYield ?? null,
      regularMarketPrice: quote.regularMarketPrice ?? null,
      regularMarketChangePercent: quote.regularMarketChangePercent ?? null,
    };
  });

  sessionStorage.setItem(cacheKey, JSON.stringify({ data: quotes, ts: Date.now() }));
  return quotes;
}

async function fetchFundamentalsFromApi(tickers) {
  const response = await fetch(`/api/fundamentals?symbols=${encodeURIComponent(tickers.join(','))}`);
  if (!response.ok) throw new Error(`Fundamentals API ${response.status}`);
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) throw new Error('Fundamentals API did not return JSON');
  const payload = await response.json();
  return payload.data || {};
}

function mergeYahooQuote(fundamentals, quote) {
  const base = fundamentals || {};
  return {
    ...base,
    marketCap: quote?.marketCap ?? null,
    trailingPE: quote?.trailingPE ?? null,
    fiftyTwoWeekHigh: quote?.fiftyTwoWeekHigh ?? null,
    fiftyTwoWeekLow: quote?.fiftyTwoWeekLow ?? null,
    dividendYield: quote?.dividendYield ?? null,
    regularMarketPrice: quote?.regularMarketPrice ?? null,
    regularMarketChangePercent: quote?.regularMarketChangePercent ?? null,
  };
}

function hasAnyValue(data) {
  if (!data) return false;
  return Object.entries(data).some(([key, value]) => (
    key !== 'rating' && key !== 'nextEarnings' && value !== null && value !== undefined && value !== ''
  ));
}

function getFallbackFundamental(ticker) {
  const fallback = fallbackStockFundamentals[ticker];
  return fallback ? { ...fallback, isFallback: true } : null;
}

function shouldUseBrowserFallbackRequests() {
  return window.location.hostname === 'localhost'
    || window.location.hostname === '127.0.0.1';
}

function cikPadded(cik) {
  return cik.replace(/^0+/, '').padStart(10, '0');
}

function pickEntriesByUnit(units) {
  return units?.USD || units?.shares || units?.['USD/shares'] || units?.pure || null;
}

function getLatestQuarterly(facts, taxonomy, tag) {
  const units = facts?.facts?.[taxonomy]?.[tag]?.units;
  const entries = pickEntriesByUnit(units);
  if (!entries || !entries.length) return null;

  const quarterly = entries
    .filter((entry) => entry.form === '10-Q' || entry.form === '10-K')
    .filter((entry) => entry.val !== null && entry.val !== undefined && entry.end)
    .sort((a, b) => b.end.localeCompare(a.end) || (b.filed || '').localeCompare(a.filed || ''));

  if (!quarterly.length) return null;
  const latest = quarterly[0];
  const prev = quarterly.find((entry) => entry.end !== latest.end);
  return {
    value: latest.val,
    end: latest.end,
    filed: latest.filed || null,
    prevVal: prev?.val ?? null,
  };
}

function getLatestQuarterlyAny(facts, taxonomy, tags) {
  for (const tag of tags) {
    const value = getLatestQuarterly(facts, taxonomy, tag);
    if (value) return value;
  }
  return null;
}

function estimateNextEarnings(filedDates) {
  if (!filedDates || filedDates.length < 2) return null;
  const sorted = [...filedDates].sort((a, b) => b.localeCompare(a));
  const last = new Date(sorted[0]);
  const next = new Date(last);
  next.setMonth(next.getMonth() + 3);
  return next.toISOString().slice(0, 10);
}

function getRating(netIncome, revenueGrowth) {
  if (netIncome > 0 && revenueGrowth > 0) return 'buy';
  if (netIncome > 0) return 'hold';
  return 'watch';
}

async function fetchStockFacts(stock) {
  const cacheKey = `stock_facts_${stock.ticker}`;
  const cached = sessionStorage.getItem(cacheKey);
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      if (Date.now() - parsed.ts < 86400000) return parsed.data;
    } catch { /* ignore bad cache */ }
  }

  const [factsRes, submissionsRes] = await Promise.allSettled([
    fetch(`https://data.sec.gov/api/xbrl/companyfacts/CIK${cikPadded(stock.cik)}.json`, { headers: SEC_HEADERS }),
    fetch(`https://data.sec.gov/submissions/CIK${cikPadded(stock.cik)}.json`, { headers: SEC_HEADERS }),
  ]);

  let revenue = null;
  let netIncome = null;
  let eps = null;
  let totalAssets = null;
  let grossProfit = null;
  let operatingIncome = null;
  let cashFlow = null;
  let sharesOut = null;
  let nextEarnings = null;

  if (factsRes.status === 'fulfilled' && factsRes.value.ok) {
    const facts = await factsRes.value.json();
    revenue = getLatestQuarterlyAny(facts, 'us-gaap', [
      'RevenueFromContractWithCustomerExcludingAssessedTax',
      'SalesRevenueNet',
      'Revenues',
      'RevenueFromContractWithCustomerIncludingAssessedTax',
      'InterestAndDividendIncomeOperating',
    ]);
    netIncome = getLatestQuarterlyAny(facts, 'us-gaap', ['NetIncomeLoss', 'ProfitLoss']);
    eps = getLatestQuarterlyAny(facts, 'us-gaap', ['EarningsPerShareDiluted', 'EarningsPerShareBasic']);
    totalAssets = getLatestQuarterly(facts, 'us-gaap', 'Assets');
    grossProfit = getLatestQuarterly(facts, 'us-gaap', 'GrossProfit');
    operatingIncome = getLatestQuarterlyAny(facts, 'us-gaap', [
      'OperatingIncomeLoss',
      'IncomeLossFromContinuingOperationsBeforeIncomeTaxesExtraordinaryItemsNoncontrollingInterest',
    ]);
    cashFlow = getLatestQuarterlyAny(facts, 'us-gaap', [
      'NetCashProvidedByUsedInOperatingActivities',
      'NetCashProvidedByUsedInOperatingActivitiesContinuingOperations',
    ]);
    sharesOut = getLatestQuarterlyAny(facts, 'dei', ['EntityCommonStockSharesOutstanding'])
      || getLatestQuarterlyAny(facts, 'us-gaap', [
        'WeightedAverageNumberOfDilutedSharesOutstanding',
        'WeightedAverageNumberOfSharesOutstandingBasic',
        'CommonStockSharesOutstanding',
      ]);
  }

  if (submissionsRes.status === 'fulfilled' && submissionsRes.value.ok) {
    const sub = await submissionsRes.value.json();
    const filingDates = [];
    const forms = sub.filings?.recent?.form || [];
    const dates = sub.filings?.recent?.filingDate || [];
    for (let i = 0; i < forms.length; i += 1) {
      if ((forms[i] === '10-Q' || forms[i] === '10-K') && dates[i]) filingDates.push(dates[i]);
    }
    nextEarnings = estimateNextEarnings(filingDates);
  }

  const revVal = revenue?.value ?? null;
  const revPrev = revenue?.prevVal ?? null;
  const revenueGrowth = revVal !== null && revPrev ? ((revVal - revPrev) / Math.abs(revPrev)) * 100 : null;
  const niVal = netIncome?.value ?? null;
  const niInBillions = niVal !== null ? niVal / 1e9 : null;
  const revInBillions = revVal !== null ? revVal / 1e9 : null;

  const result = {
    revenue: revInBillions,
    revenueEnd: revenue?.end || null,
    netIncome: niInBillions,
    netIncomeEnd: netIncome?.end || null,
    eps: eps?.value ?? null,
    totalAssets: totalAssets?.value ? totalAssets.value / 1e9 : null,
    grossProfit: grossProfit?.value ? grossProfit.value / 1e9 : null,
    operatingIncome: operatingIncome?.value ? operatingIncome.value / 1e9 : null,
    cashFlow: cashFlow?.value ? cashFlow.value / 1e9 : null,
    sharesOut: sharesOut?.value ?? null,
    revenueGrowth,
    nextEarnings,
    rating: getRating(niInBillions || 0, revenueGrowth || 0),
  };

  sessionStorage.setItem(cacheKey, JSON.stringify({ data: result, ts: Date.now() }));
  return result;
}

export async function fetchAllStockFundamentals(tickers = STOCKS.map((stock) => stock.ticker)) {
  const results = {};
  const selectedStocks = tickers
    .map((ticker) => STOCKS.find((stock) => stock.ticker === ticker))
    .filter(Boolean);

  try {
    const apiData = await fetchFundamentalsFromApi(tickers);
    if (Object.keys(apiData).length) {
      const mergedApiData = {};
      selectedStocks.forEach((stock) => {
        mergedApiData[stock.ticker] = hasAnyValue(apiData[stock.ticker])
          ? apiData[stock.ticker]
          : getFallbackFundamental(stock.ticker);
      });
      return mergedApiData;
    }
  } catch { /* fall through to local-only direct requests or static fallback */ }

  if (!shouldUseBrowserFallbackRequests()) {
    selectedStocks.forEach((stock) => {
      results[stock.ticker] = getFallbackFundamental(stock.ticker);
    });
    return results;
  }

  let quotes = {};
  try {
    quotes = await fetchYahooQuotes(tickers);
  } catch { /* keep SEC data when Yahoo is unavailable */ }

  await Promise.allSettled(
    selectedStocks.map(async (stock) => {
      try {
        const data = await fetchStockFacts(stock);
        const merged = mergeYahooQuote(data, quotes[stock.ticker]);
        results[stock.ticker] = hasAnyValue(merged) ? merged : null;
      } catch {
        const merged = mergeYahooQuote(null, quotes[stock.ticker]);
        results[stock.ticker] = hasAnyValue(merged) ? merged : null;
      }
    })
  );

  selectedStocks.forEach((stock) => {
    if (!hasAnyValue(results[stock.ticker])) {
      results[stock.ticker] = getFallbackFundamental(stock.ticker);
    }
  });

  return results;
}

export async function fetchStockDetail(ticker) {
  const stock = STOCKS.find((item) => item.ticker === ticker);
  if (!stock) return null;
  try {
    const apiData = await fetchFundamentalsFromApi([stock.ticker]);
    if (apiData[stock.ticker]) return apiData[stock.ticker];
  } catch { /* fall through to local-only direct requests or static fallback */ }

  if (!shouldUseBrowserFallbackRequests()) {
    return getFallbackFundamental(stock.ticker);
  }

  try {
    let quote = null;
    try {
      quote = (await fetchYahooQuotes([stock.ticker]))[stock.ticker];
    } catch { /* ignore Yahoo failure */ }
    const data = await fetchStockFacts(stock);
    const merged = mergeYahooQuote(data, quote);
    return hasAnyValue(merged) ? merged : getFallbackFundamental(stock.ticker);
  } catch {
    return getFallbackFundamental(stock.ticker);
  }
}
